import { QueryFunctionContext } from '@tanstack/react-query';
import { baseQuery } from '../baseQuery';
import { DefaultOptionType } from 'antd/es/select';

export const getDiscountTypeTemplates = async ({
  queryKey: _queryKey,
}: QueryFunctionContext<[string, number | undefined]>): Promise<DefaultOptionType[]> => {
  const { data } = await baseQuery('discount-type-templates');

  return data;
};
